import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import colorStyles from './style/color.css';
import generalStyles from './style/general.css';

import loaderSize from '../sizes.spec';

const cx = classNames.bind({
  ...colorStyles,
  ...generalStyles,
});

export default function Loader({ size, color }) {
  const smallBorder = size === 'extraSmall' || size === 'small';

  const className = cx('loader', color);

  const style = {
    width: loaderSize[size],
    height: loaderSize[size],
    borderWidth: smallBorder ? 1 : 2,
  };

  return <div className={className} style={style} />;
}

Loader.propTypes = {
  size: PropTypes.oneOf(Object.keys(loaderSize)),
  color: PropTypes.oneOf(Object.keys(colorStyles)),
};

Loader.defaultProps = {
  size: 'medium',
  color: 'silver',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-loader/Loader/index.js